import React, {
  forwardRef,
  useCallback,
  useImperativeHandle,
  useRef,
  useState,
} from 'react';
import styled from 'styled-components';
import { InputNumber, InputType } from 'components/atoms/input';
import { CellRendererParams } from '../../types';

const StyledInputNumber = styled(InputNumber)`
  min-width: auto;
  outline: none; /* outline is not needed because ag-grid cell will have focus outline */
`;

export const NumberEditor = forwardRef<unknown, CellRendererParams>(
  ({ value, data }, ref) => {
    const inputRef = useRef<InputType>(null);
    const [state, setValue] = useState<number>(value);

    const onChange = useCallback(
      (latest: number | string | undefined | null) => {
        const num = Number(latest ?? 1);

        setValue(num);
      },
      [],
    );

    useImperativeHandle(ref, () => {
      return {
        getValue: () => {
          return state;
        },
        afterGuiAttached: () => {
          setValue(value);
          inputRef?.current?.focus();
          inputRef?.current?.select();
        },
      };
    });
    const { title } = data;

    if (!title) {
      return null;
    }

    return (
      <StyledInputNumber
        min={1}
        ref={inputRef}
        value={state}
        onChange={onChange}
      />
    );
  },
);
